<!-- Divider -->
<div
    class="horizontal-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
